import { AccordionBodyItemView } from 'component/Accordion';
import { React, useEffect, useState } from 'react';
import { getDonorById } from 'api/DonorsApi';

export const DonorView = (props) => {
  const [donorName, setDonorName] = useState(null);
  const { formData, prefetchedName, subId } = props;

  const getDonorName = (donorId) => {
    getDonorById(donorId)
      .then((res) => {
        setDonorName(res?.data?.name);
      })
      .catch((err) => {
        console.error(err);
        setDonorName(null);
      });
  };

  useEffect(() => {
    if (prefetchedName !== undefined) return;
    const donorId = formData?.donor ?? formData?.info?.general?.donor ?? formData?.info?.donor;
    if (!donorId) return;
    const id = typeof donorId === 'object' ? donorId?.value ?? donorId?.id : donorId;
    getDonorName(id);
  }, [formData?.donor, formData?.info?.general?.donor, formData?.info?.donor, prefetchedName]);


  return (
    <AccordionBodyItemView
      accordionSubId={(
        <div>
          {subId && <span>{subId}</span>}
          {!subId && <span />}
        </div>
      )}
      titleUA="Донор"
      titleEN="Donor"
      children={(
        <div className="flex-group no-wrap">
          {prefetchedName ?? donorName ?? 'Відсутній'}
        </div>
      )}
    />
  );
};
